
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import moment from 'moment';
    import { SweetAlertResult } from 'sweetalert2';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Impfung from '@/types/Impfung';
    import Patient from '@/types/Patient';
    import { ValidationRules } from '@/store/types';
    import { confirmSwal } from '@/helper/swals';
    import {VForm, createAutocompleteFilter, VDatePickerInput} from '@/types/Components';
    import PatAnamnese from '@/types/PatAnamnese';
    import DatePickerInput from '@/components/DatePickerInput.vue';
    import _ from 'lodash';
    import api from '@/services/Api';
    import {AxiosResponse} from 'axios';

    @Component({
        components: {
            EingetragenAmVom,
            DatePickerInput,
        },
        computed: {
            ...mapState('globals', ['rules', 'formatDate', 'parseDate']),
            ...mapState('session', ['arzt', 'abrechnungLeistung']),
            ...mapState('patient', ['patientData', 'loaders', 'dialogs']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapGetters('personen', ['getPersonen']),
            ...mapState('personen', { personenLoaders: 'loaders' }),
        },
        methods: {
            ...mapActions('patient', ['createAnamneseneintrag', 'deleteAnamneseneintrag', 'printAnamnese']),
            ...mapMutations('patient', ['setDialogAnamnese']),
            ...mapMutations('session', ['setSelectedArzt']),
        },
    })
    export default class AnamneseneintragDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() value!: Impfung;

        public $refs!: {
            form: VForm;
            anamnesedatum: VDatePickerInput
        };

        public rules!: ValidationRules;
        public patientData!: Patient;
        public impfstelle_id!: number;
        public formatDate!: (input: string | null) => string | null;
        public parseDate!: (input: string | null) => string | null;
        public createAnamneseneintrag!: (payload: {data: Impfung, print: boolean}) => void;
        public deleteAnamneseneintrag!: (data: Impfung) => void;
        public setDialogAnamnese!: (visible: boolean) => void;

        public tabIndex = 'tabIndex';
        public dialogs!: any;

        public data = new Impfung();
        public arzt!: number | null;

        public get isNew(): boolean {
            return this.data.patimpfung_id === null;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (!visible) return;

            if (!this.dialogs.anamneselistitem) {
                api.post('ivs/patimpfungen/checkanamnese', {patnr: this.patientData.patnr})
                    .then((response: AxiosResponse) => {
                        if (response.data.body.patimpfung_id) {
                            this.data = new Impfung(response.data.body);
                        } else {
                            this.data = new Impfung();
                            this.data.anzahl = 1;
                            this.data.patnr = this.patientData.patnr;
                            this.data.impfdatum = moment().format('YYYY-MM-DD');
                            if (this.data.anamnese) {
                                this.data.anamnese.patnr = this.patientData.patnr;
                                this.data.anamnese.datum = this.data.impfdatum;
                            }

                            if (this.arzt) {
                                this.data.person_id_durchf = this.arzt;
                            }
                        }
                    })
                    .catch(console.error);
            } else {
                this.data = new Impfung(this.value);
            }

            if (this.isNew) {
                this.data.anzahl = 1;
                this.data.patnr = this.patientData.patnr;
                this.data.impfdatum = moment().format('YYYY-MM-DD');
                if (this.data.anamnese) {
                    this.data.anamnese.patnr = this.patientData.patnr;
                }

                if (this.arzt) {
                    this.data.person_id_durchf = this.arzt;
                }
            }

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }

        public onClickSave(): void {
            if (!this.$refs.form.validate() || this.impfdatumErrorMessages.length > 0) {
                return;
            }

            this.createAnamneseneintrag({data: this.data, print: false});
        }

        public onClickPrint(): void {
            if (!this.$refs.form.validate() || this.impfdatumErrorMessages.length > 0) {
                return;
            }

            this.createAnamneseneintrag({data: this.data, print: true});
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Anamneseneintrag endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({isConfirmed}: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteAnamneseneintrag(this.data);
                    }
                });
        }

        public close(): void {
            this.$emit('close');
            this.setDialogAnamnese(false);
        }

        public impfdatumMenu = false;
        public impfdatumFormatted: string | null = null;
        public impfdatumErrorMessages: string[] = [];

        @Watch('data.impfdatum')
        public onChangeImpfdatum(date: string | null): void {
            this.impfdatumFormatted = this.formatDate(this.data.impfdatum);

            if (date !== null && this.isNew) {
                this.impfdatumErrorMessages = [];

                for (const rule of [this.rules.required, this.rules.validDate]) {
                    const valid = rule(this.data.impfdatum);
                    if (valid !== true) {
                        this.impfdatumErrorMessages.push(valid as string);
                    }
                }

                if (this.data.impfdatum && (this.data.impfdatum > moment().format('YYYY-MM-DD'))) {
                    this.impfdatumErrorMessages.push('Datum darf nicht in der Zukunft sein.');
                }

                if (this.data.anamnese) {
                    this.data.anamnese.datum = this.data.impfdatum;
                }
            }
        }

        public getPreivious() {
            var activeTab = document.querySelectorAll('.anamnese .v-tab--active')[0];
            var indexOfActive = activeTab.getAttribute('tabindex');

            if (Number(indexOfActive) > 1) {
                var indexOfPrev = Number(indexOfActive) - 1;
                var prevTab = document.querySelectorAll(`.anamnese [tabindex = '${indexOfPrev}'] `)[0];
                var prevTabID = prevTab.getAttribute('id');

                if (prevTabID) {
                    var element = document.getElementById(`${prevTabID}`);
                    if (element) {
                        element.click();
                    }
                }

                activeTab.classList.remove('v-tab--active');
                activeTab.setAttribute('aria-selected', 'false');
                prevTab.classList.add('v-tab--active');
                prevTab.setAttribute('aria-selected', 'true');

                document.getElementById('anamnese-tabs')?.scrollIntoView({ behavior: 'smooth' });
            }
        }

        public getNext() {
            var activeTab = document.querySelectorAll('.anamnese .v-tab--active')[0];
            var indexOfActive = activeTab.getAttribute('tabindex');

            if (Number(indexOfActive) < 3) {
                var indexOfNext = Number(indexOfActive) + 1;
                var nextTab = document.querySelectorAll(`.anamnese [tabindex = '${indexOfNext}'] `)[0];
                var nextTabID = nextTab.getAttribute('id');

                if (nextTabID) {
                    var element = document.getElementById(`${nextTabID}`);
                    if (element) {
                        element.click();
                    }
                }

                activeTab.classList.remove('v-tab--active');
                activeTab.setAttribute('aria-selected', 'false');
                nextTab.classList.add('v-tab--active');
                nextTab.setAttribute('aria-selected', 'true');

                document.getElementById('anamnese-tabs')?.scrollIntoView({ behavior: 'smooth' });
            }
        }

        @Watch('data.anamnese.kk_masern_n')
        public changeOnKKMasern_n() {
            if (this.data.anamnese.kk_masern_n === 'j') {
                this.data.anamnese.kk_masern = 'n';
            }
        }

        @Watch('data.anamnese.kk_masern')
        public changeOnKKMasern() {
            if (this.data.anamnese.kk_masern === 'j' && this.data.anamnese.kk_masern_n === 'j') {
                this.data.anamnese.kk_masern_n = 'n';
            }
        }

        @Watch('data.anamnese.kk_mumps_n')
        public changeOnKKMumps_n() {
            if (this.data.anamnese.kk_mumps_n === 'j') {
                this.data.anamnese.kk_mumps = 'n';
            }
        }

        @Watch('data.anamnese.kk_mumps')
        public changeOnKKMumps() {
            if (this.data.anamnese.kk_mumps === 'j' && this.data.anamnese.kk_mumps_n === 'j') {
                this.data.anamnese.kk_mumps_n = 'n';
            }
        }

        @Watch('data.anamnese.kk_roeteln_n')
        public changeOnKKRoeteln_n() {
            if (this.data.anamnese.kk_roeteln_n === 'j') {
                this.data.anamnese.kk_roeteln = 'n';
            }
        }

        @Watch('data.anamnese.kk_roeteln')
        public changeOnKKRoeteln() {
            if (this.data.anamnese.kk_roeteln === 'j' && this.data.anamnese.kk_roeteln_n === 'j') {
                this.data.anamnese.kk_roeteln_n = 'n';
            }
        }

        @Watch('data.anamnese.kk_windpocken_n')
        public changeOnKKWindpocken_n() {
            if (this.data.anamnese.kk_windpocken_n === 'j') {
                this.data.anamnese.kk_windpocken = 'n';
            }
        }

        @Watch('data.anamnese.kk_windpocken')
        public changeOnKKWindpocken() {
            if (this.data.anamnese.kk_windpocken === 'j' && this.data.anamnese.kk_windpocken_n === 'j') {
                this.data.anamnese.kk_windpocken_n = 'n';
            }
        }

        @Watch('data.anamnese.kk_keuchhusten_n')
        public changeOnKKKeuchhusten_n() {
            if (this.data.anamnese.kk_keuchhusten_n === 'j') {
                this.data.anamnese.kk_keuchhusten = 'n';
            }
        }

        @Watch('data.anamnese.kk_keuchhusten')
        public changeOnKKKeuchhusten() {
            if (this.data.anamnese.kk_keuchhusten === 'j' && this.data.anamnese.kk_keuchhusten_n === 'j') {
                this.data.anamnese.kk_keuchhusten_n = 'n';
            }
        }

        @Watch('data.anamnese.kk_scharlach_n')
        public changeOnKKScharlach_n() {
            if (this.data.anamnese.kk_scharlach_n === 'j') {
                this.data.anamnese.kk_scharlach = 'n';
            }
        }

        @Watch('data.anamnese.kk_scharlach')
        public changeOnKKScharlach() {
            if (this.data.anamnese.kk_scharlach === 'j' && this.data.anamnese.kk_scharlach_n === 'j') {
                this.data.anamnese.kk_scharlach_n = 'n';
            }
        }

        @Watch('data.anamnese.kk_nicht_erinnerlich_n')
        public changeOnKKNichterrinnerlich_n() {
            if (this.data.anamnese.kk_nicht_erinnerlich_n === 'j') {
                this.data.anamnese.kk_nicht_erinnerlich = 'n';
            }
        }

        @Watch('data.anamnese.kk_nicht_erinnerlich')
        public changeOnKKNichterrinnerlich() {
            if (this.data.anamnese.kk_nicht_erinnerlich === 'j' && this.data.anamnese.kk_nicht_erinnerlich_n === 'j') {
                this.data.anamnese.kk_nicht_erinnerlich_n = 'n';
            }
        }

        @Watch('data.anamnese.fam_haeufige_krankheiten_n')
        public changeOnFamkrankheiten_n() {
            if (this.data.anamnese.fam_haeufige_krankheiten_n === 'j') {
                this.data.anamnese.fam_haeufige_krankheiten = 'n';
                this.data.anamnese.fam_haeufige_krankheiten_text = '';
            }
            if (this.data.anamnese.fam_haeufige_krankheiten_n === 'n' && this.data.anamnese.fam_haeufige_krankheiten === 'n') {
                this.data.anamnese.fam_haeufige_krankheiten = null;
            }
        }

        @Watch('data.anamnese.fam_haeufige_krankheiten')
        public changeOnFamkrankheiten() {
            if (this.data.anamnese.fam_haeufige_krankheiten === 'j' && this.data.anamnese.fam_haeufige_krankheiten_n === 'j') {
                this.data.anamnese.fam_haeufige_krankheiten_n = 'n';
            }
            if (this.data.anamnese.fam_haeufige_krankheiten_n === 'n' && this.data.anamnese.fam_haeufige_krankheiten === 'n') {
                this.data.anamnese.fam_haeufige_krankheiten = null;
            }
        }

        @Watch('data.anamnese.gp_medikamente_n')
        public changeOnGPMedikamente_n() {
            if (this.data.anamnese.gp_medikamente_n === 'j') {
                this.data.anamnese.gp_medikamente = 'n';
                this.data.anamnese.gp_medikamente_text = '';
            }
            if (this.data.anamnese.gp_medikamente_n === 'n' && this.data.anamnese.gp_medikamente === 'n') {
                this.data.anamnese.gp_medikamente = null;
            }
        }

        @Watch('data.anamnese.gp_medikamente')
        public changeOnGPMedikamente() {
            if (this.data.anamnese.gp_medikamente === 'j' && this.data.anamnese.gp_medikamente_n === 'j') {
                this.data.anamnese.gp_medikamente_n = 'n';
            }
            if (this.data.anamnese.gp_medikamente_n === 'n' && this.data.anamnese.gp_medikamente === 'n') {
                this.data.anamnese.gp_medikamente = null;
            }
        }

        @Watch('data.anamnese.gp_allergien_n')
        public changeOnGPAllergien_n() {
            if (this.data.anamnese.gp_allergien_n === 'j') {
                this.data.anamnese.gp_allergien = 'n';
                this.data.anamnese.gp_allergien_text = '';
            }
            if (this.data.anamnese.gp_allergien_n === 'n' && this.data.anamnese.gp_allergien === 'n') {
                this.data.anamnese.gp_allergien = null;
            }
        }

        @Watch('data.anamnese.gp_allergien')
        public changeOnGPAllergien() {
            if (this.data.anamnese.gp_allergien === 'j' && this.data.anamnese.gp_allergien_n === 'j') {
                this.data.anamnese.gp_allergien_n = 'n';
            }
            if (this.data.anamnese.gp_allergien_n === 'n' && this.data.anamnese.gp_allergien === 'n') {
                this.data.anamnese.gp_allergien = null;
            }
        }

        @Watch('data.anamnese.gp_alkohol_n')
        public changeOnGPAlkohol_n() {
            if (this.data.anamnese.gp_alkohol_n === 'j') {
                this.data.anamnese.gp_alkohol = 'n';
                this.data.anamnese.gp_alkohol_text = '';
            }
            if (this.data.anamnese.gp_alkohol_n === 'n' && this.data.anamnese.gp_alkohol === 'n') {
                this.data.anamnese.gp_alkohol = null;
            }
        }

        @Watch('data.anamnese.gp_alkohol')
        public changeOnGPAlkohol() {
            if (this.data.anamnese.gp_alkohol === 'j' && this.data.anamnese.gp_alkohol_n === 'j') {
                this.data.anamnese.gp_alkohol_n = 'n';
            }
            if (this.data.anamnese.gp_alkohol_n === 'n' && this.data.anamnese.gp_alkohol === 'n') {
                this.data.anamnese.gp_alkohol = null;
            }
        }

        @Watch('data.anamnese.gp_medikamentenunvertraeglichkeit_n')
        public changeOnGPMedUnvertr_n() {
            if (this.data.anamnese.gp_medikamentenunvertraeglichkeit_n === 'j') {
                this.data.anamnese.gp_medikamentenunvertraeglichkeit = 'n';
                this.data.anamnese.gp_medikamentenunvertraeglichkeit_text = '';
            }
            if (this.data.anamnese.gp_medikamentenunvertraeglichkeit_n === 'n' && this.data.anamnese.gp_medikamentenunvertraeglichkeit === 'n') {
                this.data.anamnese.gp_medikamentenunvertraeglichkeit = null;
            }
        }

        @Watch('data.anamnese.gp_medikamentenunvertraeglichkeit')
        public changeOnGPMedUnvertr() {
            if (this.data.anamnese.gp_medikamentenunvertraeglichkeit === 'j' && this.data.anamnese.gp_medikamentenunvertraeglichkeit_n === 'j') {
                this.data.anamnese.gp_medikamentenunvertraeglichkeit_n = 'n';
            }
            if (this.data.anamnese.gp_medikamentenunvertraeglichkeit_n === 'n' && this.data.anamnese.gp_medikamentenunvertraeglichkeit === 'n') {
                this.data.anamnese.gp_medikamentenunvertraeglichkeit = null;
            }
        }

        @Watch('data.anamnese.gp_rauchen_n')
        public changeOnGPRauchen_n() {
            if (this.data.anamnese.gp_rauchen_n === 'j') {
                this.data.anamnese.gp_rauchen = 'n';
                this.data.anamnese.gp_rauchen_text = '';
            }
            if (this.data.anamnese.gp_rauchen_n === 'n' && this.data.anamnese.gp_rauchen === 'n') {
                this.data.anamnese.gp_rauchen = null;
            }
        }

        @Watch('data.anamnese.gp_rauchen')
        public changeOnGPRauchen() {
            if (this.data.anamnese.gp_rauchen === 'j' && this.data.anamnese.gp_rauchen_n === 'j') {
                this.data.anamnese.gp_rauchen_n = 'n';
            }
            if (this.data.anamnese.gp_rauchen_n === 'n' && this.data.anamnese.gp_rauchen === 'n') {
                this.data.anamnese.gp_rauchen = null;
            }
        }

        @Watch('data.anamnese.gp_drogen_n')
        public changeOnGPDrogen_n() {
            if (this.data.anamnese.gp_drogen_n === 'j') {
                this.data.anamnese.gp_drogen = 'n';
                this.data.anamnese.gp_drogen_text = '';
            }
            if (this.data.anamnese.gp_drogen_n === 'n' && this.data.anamnese.gp_drogen === 'n') {
                this.data.anamnese.gp_drogen = null;
            }
        }

        @Watch('data.anamnese.gp_drogen')
        public changeOnGPDrogen() {
            if (this.data.anamnese.gp_drogen === 'j' && this.data.anamnese.gp_drogen_n === 'j') {
                this.data.anamnese.gp_drogen_n = 'n';
            }
            if (this.data.anamnese.gp_drogen_n === 'n' && this.data.anamnese.gp_drogen === 'n') {
                this.data.anamnese.gp_drogen = null;
            }
        }

        @Watch('data.anamnese.gp_sport_n')
        public changeOnGPSport_n() {
            if (this.data.anamnese.gp_sport_n === 'j') {
                this.data.anamnese.gp_sport = 'n';
                this.data.anamnese.gp_sport_text = '';
            }
            if (this.data.anamnese.gp_sport_n === 'n' && this.data.anamnese.gp_sport === 'n') {
                this.data.anamnese.gp_sport = null;
            }
        }

        @Watch('data.anamnese.gp_sport')
        public changeOnGPSport() {
            if (this.data.anamnese.gp_sport === 'j' && this.data.anamnese.gp_sport_n === 'j') {
                this.data.anamnese.gp_sport_n = 'n';
            }
            if (this.data.anamnese.gp_sport_n === 'n' && this.data.anamnese.gp_sport === 'n') {
                this.data.anamnese.gp_sport = null;
            }
        }

        @Watch('data.anamnese.gp_durchfall_verstopfung_n')
        public changeOnGPDurchfall_n() {
            if (this.data.anamnese.gp_durchfall_verstopfung_n === 'j') {
                this.data.anamnese.gp_durchfall_verstopfung = 'n';
                this.data.anamnese.gp_durchfall_verstopfung_text = '';
            }
            if (this.data.anamnese.gp_durchfall_verstopfung_n === 'n' && this.data.anamnese.gp_durchfall_verstopfung === 'n') {
                this.data.anamnese.gp_durchfall_verstopfung = null;
            }
        }

        @Watch('data.anamnese.gp_durchfall_verstopfung')
        public changeOnGPDurchfall() {
            if (this.data.anamnese.gp_durchfall_verstopfung === 'j' && this.data.anamnese.gp_durchfall_verstopfung_n === 'j') {
                this.data.anamnese.gp_durchfall_verstopfung_n = 'n';
            }
            if (this.data.anamnese.gp_durchfall_verstopfung_n === 'n' && this.data.anamnese.gp_durchfall_verstopfung === 'n') {
                this.data.anamnese.gp_durchfall_verstopfung = null;
            }
        }

        @Watch('data.anamnese.gp_urinieren_n')
        public changeOnGPUrin_n() {
            if (this.data.anamnese.gp_urinieren_n === 'j') {
                this.data.anamnese.gp_urinieren = 'n';
                this.data.anamnese.gp_urinieren_text = '';
            }
            if (this.data.anamnese.gp_urinieren_n === 'n' && this.data.anamnese.gp_urinieren === 'n') {
                this.data.anamnese.gp_urinieren = null;
            }
        }

        @Watch('data.anamnese.gp_urinieren')
        public changeOnGPUrin() {
            if (this.data.anamnese.gp_urinieren === 'j' && this.data.anamnese.gp_urinieren_n === 'j') {
                this.data.anamnese.gp_urinieren_n = 'n';
            }
            if (this.data.anamnese.gp_urinieren_n === 'n' && this.data.anamnese.gp_urinieren === 'n') {
                this.data.anamnese.gp_urinieren = null;
            }
        }

        @Watch('data.anamnese.gp_schlafstoerungen_n')
        public changeOnGPSchlaf_n() {
            if (this.data.anamnese.gp_schlafstoerungen_n === 'j') {
                this.data.anamnese.gp_schlafstoerungen = 'n';
                this.data.anamnese.gp_schlafstoerungen_text = '';
            }
            if (this.data.anamnese.gp_schlafstoerungen_n === 'n' && this.data.anamnese.gp_schlafstoerungen === 'n') {
                this.data.anamnese.gp_schlafstoerungen = null;
            }
        }

        @Watch('data.anamnese.gp_schlafstoerungen')
        public changeOnGPSchlaf() {
            if (this.data.anamnese.gp_schlafstoerungen === 'j' && this.data.anamnese.gp_schlafstoerungen_n === 'j') {
                this.data.anamnese.gp_schlafstoerungen_n = 'n';
            }
            if (this.data.anamnese.gp_schlafstoerungen_n === 'n' && this.data.anamnese.gp_schlafstoerungen === 'n') {
                this.data.anamnese.gp_schlafstoerungen = null;
            }
        }

        @Watch('data.anamnese.gp_risiken_arbeitsplatz_n')
        public changeOnGPArbeitsplatz_n() {
            if (this.data.anamnese.gp_risiken_arbeitsplatz_n === 'j') {
                this.data.anamnese.gp_risiken_arbeitsplatz = 'n';
                this.data.anamnese.gp_risiken_arbeitsplatz_text = '';
            }
            if (this.data.anamnese.gp_risiken_arbeitsplatz_n === 'n' && this.data.anamnese.gp_risiken_arbeitsplatz === 'n') {
                this.data.anamnese.gp_risiken_arbeitsplatz = null;
            }
        }

        @Watch('data.anamnese.gp_risiken_arbeitsplatz')
        public changeOnGPArbeitsplatz() {
            if (this.data.anamnese.gp_risiken_arbeitsplatz === 'j' && this.data.anamnese.gp_risiken_arbeitsplatz_n === 'j') {
                this.data.anamnese.gp_risiken_arbeitsplatz_n = 'n';
            }
            if (this.data.anamnese.gp_risiken_arbeitsplatz_n === 'n' && this.data.anamnese.gp_risiken_arbeitsplatz === 'n') {
                this.data.anamnese.gp_risiken_arbeitsplatz = null;
            }
        }

        @Watch('data.anamnese.gp_beruf_n')
        public changeOnGPBeruf_n() {
            if (this.data.anamnese.gp_beruf_n === 'j') {
                this.data.anamnese.gp_beruf = 'n';
                this.data.anamnese.gp_beruf_text = '';
            }
            if (this.data.anamnese.gp_beruf_n === 'n' && this.data.anamnese.gp_beruf === 'n') {
                this.data.anamnese.gp_beruf = null;
            }
        }

        @Watch('data.anamnese.gp_beruf')
        public changeOnGPBeruf() {
            if (this.data.anamnese.gp_beruf === 'j' && this.data.anamnese.gp_beruf_n === 'j') {
                this.data.anamnese.gp_beruf_n = 'n';
            }
            if (this.data.anamnese.gp_beruf_n === 'n' && this.data.anamnese.gp_beruf === 'n') {
                this.data.anamnese.gp_beruf = null;
            }
        }

        @Watch('data.anamnese.gp_augen_n')
        public changeOnGPAugen_n() {
            if (this.data.anamnese.gp_augen_n === 'j') {
                this.data.anamnese.gp_augen = 'n';
                this.data.anamnese.gp_augen_text = '';
            }
            if (this.data.anamnese.gp_augen_n === 'n' && this.data.anamnese.gp_augen === 'n') {
                this.data.anamnese.gp_augen = null;
            }
        }

        @Watch('data.anamnese.gp_augen')
        public changeOnGPAugen() {
            if (this.data.anamnese.gp_augen === 'j' && this.data.anamnese.gp_augen_n === 'j') {
                this.data.anamnese.gp_augen_n = 'n';
            }
            if (this.data.anamnese.gp_augen_n === 'n' && this.data.anamnese.gp_augen === 'n') {
                this.data.anamnese.gp_augen = null;
            }
        }

        @Watch('data.anamnese.gp_obere_luftwege_n')
        public changeOnGPLuftwege_n() {
            if (this.data.anamnese.gp_obere_luftwege_n === 'j') {
                this.data.anamnese.gp_obere_luftwege = 'n';
                this.data.anamnese.gp_obere_luftwege_text = '';
            }
            if (this.data.anamnese.gp_obere_luftwege_n === 'n' && this.data.anamnese.gp_obere_luftwege === 'n') {
                this.data.anamnese.gp_obere_luftwege = null;
            }
        }

        @Watch('data.anamnese.gp_obere_luftwege')
        public changeOnGPLuftwege() {
            if (this.data.anamnese.gp_obere_luftwege === 'j' && this.data.anamnese.gp_obere_luftwege_n === 'j') {
                this.data.anamnese.gp_obere_luftwege_n = 'n';
            }
            if (this.data.anamnese.gp_obere_luftwege_n === 'n' && this.data.anamnese.gp_obere_luftwege === 'n') {
                this.data.anamnese.gp_obere_luftwege = null;
            }
        }

        @Watch('data.anamnese.gp_ohren_n')
        public changeOnGPOhren_n() {
            if (this.data.anamnese.gp_ohren_n === 'j') {
                this.data.anamnese.gp_ohren = 'n';
                this.data.anamnese.gp_ohren_text = '';
            }
            if (this.data.anamnese.gp_ohren_n === 'n' && this.data.anamnese.gp_ohren === 'n') {
                this.data.anamnese.gp_ohren = null;
            }
        }

        @Watch('data.anamnese.gp_ohren')
        public changeOnGPOhren() {
            if (this.data.anamnese.gp_ohren === 'j' && this.data.anamnese.gp_ohren_n === 'j') {
                this.data.anamnese.gp_ohren_n = 'n';
            }
            if (this.data.anamnese.gp_ohren_n === 'n' && this.data.anamnese.gp_ohren === 'n') {
                this.data.anamnese.gp_ohren = null;
            }
        }

        @Watch('data.anamnese.gp_atemwege_n')
        public changeOnGPAtemwege_n() {
            if (this.data.anamnese.gp_atemwege_n === 'j') {
                this.data.anamnese.gp_atemwege = 'n';
                this.data.anamnese.gp_atemwege_text = '';
            }
            if (this.data.anamnese.gp_atemwege_n === 'n' && this.data.anamnese.gp_atemwege === 'n') {
                this.data.anamnese.gp_atemwege = null;
            }
        }

        @Watch('data.anamnese.gp_atemwege')
        public changeOnGPAtemwege() {
            if (this.data.anamnese.gp_atemwege === 'j' && this.data.anamnese.gp_atemwege_n === 'j') {
                this.data.anamnese.gp_atemwege_n = 'n';
            }
            if (this.data.anamnese.gp_atemwege_n === 'n' && this.data.anamnese.gp_atemwege === 'n') {
                this.data.anamnese.gp_atemwege = null;
            }
        }

        @Watch('data.anamnese.gp_herzkreislaufsystem_n')
        public changeOnGPHerzkreis_n() {
            if (this.data.anamnese.gp_herzkreislaufsystem_n === 'j') {
                this.data.anamnese.gp_herzkreislaufsystem = 'n';
                this.data.anamnese.gp_herzkreislaufsystem_text = '';
            }
            if (this.data.anamnese.gp_herzkreislaufsystem_n === 'n' && this.data.anamnese.gp_herzkreislaufsystem === 'n') {
                this.data.anamnese.gp_herzkreislaufsystem = null;
            }
        }

        @Watch('data.anamnese.gp_herzkreislaufsystem')
        public changeOnGPHerzkreis() {
            if (this.data.anamnese.gp_herzkreislaufsystem === 'j' && this.data.anamnese.gp_herzkreislaufsystem_n === 'j') {
                this.data.anamnese.gp_herzkreislaufsystem_n = 'n';
            }
            if (this.data.anamnese.gp_herzkreislaufsystem_n === 'n' && this.data.anamnese.gp_herzkreislaufsystem === 'n') {
                this.data.anamnese.gp_herzkreislaufsystem = null;
            }
        }

        @Watch('data.anamnese.gp_verdauungstrakt_n')
        public changeOnGPVerdaaung_n() {
            if (this.data.anamnese.gp_verdauungstrakt_n === 'j') {
                this.data.anamnese.gp_verdauungstrakt = 'n';
                this.data.anamnese.gp_verdauungstrakt_text = '';
            }
            if (this.data.anamnese.gp_verdauungstrakt_n === 'n' && this.data.anamnese.gp_verdauungstrakt === 'n') {
                this.data.anamnese.gp_verdauungstrakt = null;
            }
        }

        @Watch('data.anamnese.gp_verdauungstrakt')
        public changeOnGPVerdaaung() {
            if (this.data.anamnese.gp_verdauungstrakt === 'j' && this.data.anamnese.gp_verdauungstrakt_n === 'j') {
                this.data.anamnese.gp_verdauungstrakt_n = 'n';
            }
            if (this.data.anamnese.gp_verdauungstrakt_n === 'n' && this.data.anamnese.gp_verdauungstrakt === 'n') {
                this.data.anamnese.gp_verdauungstrakt = null;
            }
        }

        @Watch('data.anamnese.gp_niere_harnwege_n')
        public changeOnGPNiereHarn_n() {
            if (this.data.anamnese.gp_niere_harnwege_n === 'j') {
                this.data.anamnese.gp_niere_harnwege = 'n';
                this.data.anamnese.gp_niere_harnwege_text = '';
            }
            if (this.data.anamnese.gp_niere_harnwege_n === 'n' && this.data.anamnese.gp_niere_harnwege === 'n') {
                this.data.anamnese.gp_niere_harnwege = null;
            }
        }

        @Watch('data.anamnese.gp_niere_harnwege')
        public changeOnGPNiereHarn() {
            if (this.data.anamnese.gp_niere_harnwege === 'j' && this.data.anamnese.gp_niere_harnwege_n === 'j') {
                this.data.anamnese.gp_niere_harnwege_n = 'n';
            }
            if (this.data.anamnese.gp_niere_harnwege_n === 'n' && this.data.anamnese.gp_niere_harnwege === 'n') {
                this.data.anamnese.gp_niere_harnwege = null;
            }
        }

        @Watch('data.anamnese.gp_haut_n')
        public changeOnGPHaut_n() {
            if (this.data.anamnese.gp_haut_n === 'j') {
                this.data.anamnese.gp_haut = 'n';
                this.data.anamnese.gp_haut_text = '';
            }
            if (this.data.anamnese.gp_haut_n === 'n' && this.data.anamnese.gp_haut === 'n') {
                this.data.anamnese.gp_haut = null;
            }
        }

        @Watch('data.anamnese.gp_haut')
        public changeOnGPHaut() {
            if (this.data.anamnese.gp_haut === 'j' && this.data.anamnese.gp_haut_n === 'j') {
                this.data.anamnese.gp_haut_n = 'n';
            }
            if (this.data.anamnese.gp_haut_n === 'n' && this.data.anamnese.gp_haut === 'n') {
                this.data.anamnese.gp_haut = null;
            }
        }

        @Watch('data.anamnese.gp_bewegungsapparat_n')
        public changeOnGPBewegung_n() {
            if (this.data.anamnese.gp_bewegungsapparat_n === 'j') {
                this.data.anamnese.gp_bewegungsapparat = 'n';
                this.data.anamnese.gp_bewegungsapparat_text = '';
            }
            if (this.data.anamnese.gp_bewegungsapparat_n === 'n' && this.data.anamnese.gp_bewegungsapparat === 'n') {
                this.data.anamnese.gp_bewegungsapparat = null;
            }
        }

        @Watch('data.anamnese.gp_bewegungsapparat')
        public changeOnGPBewegung() {
            if (this.data.anamnese.gp_bewegungsapparat === 'j' && this.data.anamnese.gp_bewegungsapparat_n === 'j') {
                this.data.anamnese.gp_bewegungsapparat_n = 'n';
            }
            if (this.data.anamnese.gp_bewegungsapparat_n === 'n' && this.data.anamnese.gp_bewegungsapparat === 'n') {
                this.data.anamnese.gp_bewegungsapparat = null;
            }
        }

        @Watch('data.anamnese.gp_stoffwechsel_n')
        public changeOnGPStoffwechsel_n() {
            if (this.data.anamnese.gp_stoffwechsel_n === 'j') {
                this.data.anamnese.gp_stoffwechsel = 'n';
                this.data.anamnese.gp_stoffwechsel_text = '';
            }
            if (this.data.anamnese.gp_stoffwechsel_n === 'n' && this.data.anamnese.gp_stoffwechsel === 'n') {
                this.data.anamnese.gp_stoffwechsel = null;
            }
        }

        @Watch('data.anamnese.gp_stoffwechsel')
        public changeOnGPStoffwechsel() {
            if (this.data.anamnese.gp_stoffwechsel === 'j' && this.data.anamnese.gp_stoffwechsel_n === 'j') {
                this.data.anamnese.gp_stoffwechsel_n = 'n';
            }
            if (this.data.anamnese.gp_stoffwechsel_n === 'n' && this.data.anamnese.gp_stoffwechsel === 'n') {
                this.data.anamnese.gp_stoffwechsel = null;
            }
        }

        @Watch('data.anamnese.gp_infektionskrankheiten_n')
        public changeOnGPInfektion_n() {
            if (this.data.anamnese.gp_infektionskrankheiten_n === 'j') {
                this.data.anamnese.gp_infektionskrankheiten = 'n';
                this.data.anamnese.gp_infektionskrankheiten_text = '';
            }
            if (this.data.anamnese.gp_infektionskrankheiten_n === 'n' && this.data.anamnese.gp_infektionskrankheiten === 'n') {
                this.data.anamnese.gp_infektionskrankheiten = null;
            }
        }

        @Watch('data.anamnese.gp_infektionskrankheiten')
        public changeOnGPInfektion() {
            if (this.data.anamnese.gp_infektionskrankheiten === 'j' && this.data.anamnese.gp_infektionskrankheiten_n === 'j') {
                this.data.anamnese.gp_infektionskrankheiten_n = 'n';
            }
            if (this.data.anamnese.gp_infektionskrankheiten_n === 'n' && this.data.anamnese.gp_infektionskrankheiten === 'n') {
                this.data.anamnese.gp_infektionskrankheiten = null;
            }
        }

        @Watch('data.anamnese.gp_tumor_n')
        public changeOnGPTumor_n() {
            if (this.data.anamnese.gp_tumor_n === 'j') {
                this.data.anamnese.gp_tumor = 'n';
                this.data.anamnese.gp_tumor_text = '';
            }
            if (this.data.anamnese.gp_tumor_n === 'n' && this.data.anamnese.gp_tumor === 'n') {
                this.data.anamnese.gp_tumor = null;
            }
        }

        @Watch('data.anamnese.gp_tumor')
        public changeOnGPTumor() {
            if (this.data.anamnese.gp_tumor === 'j' && this.data.anamnese.gp_tumor_n === 'j') {
                this.data.anamnese.gp_tumor_n = 'n';
            }
            if (this.data.anamnese.gp_tumor_n === 'n' && this.data.anamnese.gp_tumor === 'n') {
                this.data.anamnese.gp_tumor = null;
            }
        }

        @Watch('data.anamnese.gp_erkrankungen_zns_n')
        public changeOnGPZNS_n() {
            if (this.data.anamnese.gp_erkrankungen_zns_n === 'j') {
                this.data.anamnese.gp_erkrankungen_zns = 'n';
                this.data.anamnese.gp_erkrankungen_zns_text = '';
            }
            if (this.data.anamnese.gp_erkrankungen_zns_n === 'n' && this.data.anamnese.gp_erkrankungen_zns === 'n') {
                this.data.anamnese.gp_erkrankungen_zns = null;
            }
        }

        @Watch('data.anamnese.gp_erkrankungen_zns')
        public changeOnGPZNS() {
            if (this.data.anamnese.gp_erkrankungen_zns === 'j' && this.data.anamnese.gp_erkrankungen_zns_n === 'j') {
                this.data.anamnese.gp_erkrankungen_zns_n = 'n';
            }
            if (this.data.anamnese.gp_erkrankungen_zns_n === 'n' && this.data.anamnese.gp_erkrankungen_zns === 'n') {
                this.data.anamnese.gp_erkrankungen_zns = null;
            }
        }

        @Watch('data.anamnese.gp_psyche_n')
        public changeOnGPPsyche_n() {
            if (this.data.anamnese.gp_psyche_n === 'j') {
                this.data.anamnese.gp_psyche = 'n';
                this.data.anamnese.gp_psyche_text = '';
            }
            if (this.data.anamnese.gp_psyche_n === 'n' && this.data.anamnese.gp_psyche === 'n') {
                this.data.anamnese.gp_psyche = null;
            }
        }

        @Watch('data.anamnese.gp_psyche')
        public changeOnGPPsyche() {
            if (this.data.anamnese.gp_psyche === 'j' && this.data.anamnese.gp_psyche_n === 'j') {
                this.data.anamnese.gp_psyche_n = 'n';
            }
            if (this.data.anamnese.gp_psyche_n === 'n' && this.data.anamnese.gp_psyche === 'n') {
                this.data.anamnese.gp_psyche = null;
            }
        }

        @Watch('data.anamnese.gp_operationen_n')
        public changeOnGPOperation_n() {
            if (this.data.anamnese.gp_operationen_n === 'j') {
                this.data.anamnese.gp_operationen = 'n';
                this.data.anamnese.gp_operationen_text = '';
            }
            if (this.data.anamnese.gp_operationen_n === 'n' && this.data.anamnese.gp_operationen === 'n') {
                this.data.anamnese.gp_operationen = null;
            }
        }

        @Watch('data.anamnese.gp_operationen')
        public changeOnGPOperation() {
            if (this.data.anamnese.gp_operationen === 'j' && this.data.anamnese.gp_operationen_n === 'j') {
                this.data.anamnese.gp_operationen_n = 'n';
            }
            if (this.data.anamnese.gp_operationen_n === 'n' && this.data.anamnese.gp_operationen === 'n') {
                this.data.anamnese.gp_operationen = null;
            }
        }

        @Watch('data.anamnese.gp_unfaelle_n')
        public changeOnGPUnfall_n() {
            if (this.data.anamnese.gp_unfaelle_n === 'j') {
                this.data.anamnese.gp_unfaelle = 'n';
                this.data.anamnese.gp_unfaelle_text = '';
            }
            if (this.data.anamnese.gp_unfaelle_n === 'n' && this.data.anamnese.gp_unfaelle === 'n') {
                this.data.anamnese.gp_unfaelle = null;
            }
        }

        @Watch('data.anamnese.gp_unfaelle')
        public changeOnGPUnfall() {
            if (this.data.anamnese.gp_unfaelle === 'j' && this.data.anamnese.gp_unfaelle_n === 'j') {
                this.data.anamnese.gp_unfaelle_n = 'n';
            }
            if (this.data.anamnese.gp_unfaelle_n === 'n' && this.data.anamnese.gp_unfaelle === 'n') {
                this.data.anamnese.gp_unfaelle = null;
            }
        }

        @Watch('data.anamnese.gp_andere_n')
        public changeOnGPAndere_n() {
            if (this.data.anamnese.gp_andere_n === 'j') {
                this.data.anamnese.gp_andere = 'n';
                this.data.anamnese.gp_andere_text = '';
            }
            if (this.data.anamnese.gp_andere_n === 'n' && this.data.anamnese.gp_andere === 'n') {
                this.data.anamnese.gp_andere = null;
            }
        }

        @Watch('data.anamnese.gp_andere')
        public changeOnGPAndere() {
            if (this.data.anamnese.gp_andere === 'j' && this.data.anamnese.gp_andere_n === 'j') {
                this.data.anamnese.gp_andere_n = 'n';
            }
            if (this.data.anamnese.gp_andere_n === 'n' && this.data.anamnese.gp_andere === 'n') {
                this.data.anamnese.gp_andere = null;
            }
        }

        @Watch('data.anamnese.fr_kinder_n')
        public changeOnFRKinder_n() {
            if (this.data.anamnese.fr_kinder_n === 'j') {
                this.data.anamnese.fr_kinder = 'n';
                this.data.anamnese.fr_kinder_text = '';
            }
            if (this.data.anamnese.fr_kinder_n === 'n' && this.data.anamnese.fr_kinder === 'n') {
                this.data.anamnese.fr_kinder = null;
            }
        }

        @Watch('data.anamnese.fr_kinder')
        public changeOnFRKinder() {
            if (this.data.anamnese.fr_kinder === 'j' && this.data.anamnese.fr_kinder_n === 'j') {
                this.data.anamnese.fr_kinder_n = 'n';
            }
            if (this.data.anamnese.fr_kinder_n === 'n' && this.data.anamnese.fr_kinder === 'n') {
                this.data.anamnese.fr_kinder = null;
            }
        }

        @Watch('data.anamnese.fr_fehlgeburten_n')
        public changeOnFRFehl_n() {
            if (this.data.anamnese.fr_fehlgeburten_n === 'j') {
                this.data.anamnese.fr_fehlgeburten = 'n';
                this.data.anamnese.fr_fehlgeburten_text = '';
            }
            if (this.data.anamnese.fr_fehlgeburten_n === 'n' && this.data.anamnese.fr_fehlgeburten === 'n') {
                this.data.anamnese.fr_fehlgeburten = null;
            }
        }

        @Watch('data.anamnese.fr_fehlgeburten')
        public changeOnFRFehl() {
            if (this.data.anamnese.fr_fehlgeburten === 'j' && this.data.anamnese.fr_fehlgeburten_n === 'j') {
                this.data.anamnese.fr_fehlgeburten_n = 'n';
            }
            if (this.data.anamnese.fr_fehlgeburten_n === 'n' && this.data.anamnese.fr_fehlgeburten === 'n') {
                this.data.anamnese.fr_fehlgeburten = null;
            }
        }

        @Watch('data.anamnese.fr_menstruationsbeschwerden_n')
        public changeOnFRMenst_n() {
            if (this.data.anamnese.fr_menstruationsbeschwerden_n === 'j') {
                this.data.anamnese.fr_menstruationsbeschwerden = 'n';
                this.data.anamnese.fr_menstruationsbeschwerden_text = '';
            }
            if (this.data.anamnese.fr_menstruationsbeschwerden_n === 'n' && this.data.anamnese.fr_menstruationsbeschwerden === 'n') {
                this.data.anamnese.fr_menstruationsbeschwerden = null;
            }
        }

        @Watch('data.anamnese.fr_menstruationsbeschwerden')
        public changeOnFRMenst() {
            if (this.data.anamnese.fr_menstruationsbeschwerden === 'j' && this.data.anamnese.fr_menstruationsbeschwerden_n === 'j') {
                this.data.anamnese.fr_menstruationsbeschwerden_n = 'n';
            }
            if (this.data.anamnese.fr_menstruationsbeschwerden_n === 'n' && this.data.anamnese.fr_menstruationsbeschwerden === 'n') {
                this.data.anamnese.fr_menstruationsbeschwerden = null;
            }
        }

        @Watch('data.anamnese.fr_kontrazeption_n')
        public changeOnFRKont_n() {
            if (this.data.anamnese.fr_kontrazeption_n === 'j') {
                this.data.anamnese.fr_kontrazeption = 'n';
                this.data.anamnese.fr_kontrazeption_text = '';
            }

            if (this.data.anamnese.fr_kontrazeption_n === 'n' && this.data.anamnese.fr_kontrazeption === 'n') {
                this.data.anamnese.fr_kontrazeption = null;
            }
        }

        @Watch('data.anamnese.fr_kontrazeption')
        public changeOnFRKont() {
            if (this.data.anamnese.fr_kontrazeption === 'j' && this.data.anamnese.fr_kontrazeption_n === 'j') {
                this.data.anamnese.fr_kontrazeption_n = 'n';
            }
            if (this.data.anamnese.fr_kontrazeption_n === 'n' && this.data.anamnese.fr_kontrazeption === 'n') {
                this.data.anamnese.fr_kontrazeption = null;
            }
        }
    }
